import React from "react";
import { Image } from "antd";

type ImageWithDescriptionProps = {
  src: string;
  width: number | string;
  description: string;
  style?: React.CSSProperties;
};

const ImageWithDescription = ({
  width,
  src,
  description,
  style,
}: ImageWithDescriptionProps) => {
  const maxWidth = typeof width === "number" ? `${width}px` : width;

  return (
    <div
      className="image-with-description"
      style={{
        maxWidth,
        ...style,
      }}
    >
      <Image
        preview={true}
        width="100%"
        style={{ display: "block", margin: "0 auto", maxWidth }}
        src={src}
        alt={description}
      />
      <p>{description}</p>
    </div>
  );
};

export default ImageWithDescription;
